enum PageNames {
    Login = "Login",
    ResetPassword = "ResetPassword",
    Dashboard = "Dashboard",
    ThirdPartyAccounts = "ThirdPartyAccounts",
    ThirdPartyAccount = "ThirdPartyAccount",
    InstitutionAccounts = "InstitutionAccounts",
    InstitutionAccount = "InstitutionAccount",
    DepositAccounts = "DepositAccounts",
    DepositAccount = "DepositAccount",
    LendingAccounts = "LendingAccounts",
    LendingAccount = "LendingAccount",
    Customers = "Customers",
    Customer = "Customer",
    People = "People",
    Person = "Person",
    Organisations = "Organisations",
    Organisation = "Organisation",
    Products = "Products",
    Product = "Product",
    ProductIssues = "ProductIssues",
    ProductIssue = "ProductIssue",
    ProductMigrations = "ProductMigrations",
    ProductMigration = "ProductMigration",
    RateSources = "RateSources",
    RateSource = "RateSource",
    SubTransactionTypes = "SubTransactionTypes",
    SubTransactionType = "SubTransactionType",
    ProductWizard = "ProductWizard",
    ProductWizardSelector = "ProductWizardSelector",
    Reports = "Reports",
    GeneralLedgerAccounts = "GeneralLedgerAccounts",
    GeneralLedgerAccount = "GeneralLedgerAccount",
    JournalEntries = "JournalEntries",
    JournalEntry = "JournalEntry",
    Users = "Users",
    User = "User",
    Roles = "Roles",
    Role = "Role",
    AppMediums = "AppMediums",
    AppMedium = "AppMedium",
    Webhooks = "Webhooks",
    Webhook = "Webhook",
    Institutions = "Institutions",
    Institution = "Institution",
    Regions = "Regions",
    Region = "Region",
    CoreApiDocumentation = "CoreApiDocumentation",
    FiDocumentation = "FiDocumentation",
    FiCustomDocumentation = "FiCustomDocumentation",
    UxDocumentation = "UxDocumentation",
    UxCustomDocumentation = "UxCustomDocumentation",
    Sso = "Sso"
}
export default PageNames;